import { ModuleModel } from '../../module.model.interface';
import { DataEntryDescriptor } from '../../dataentry/model/dataentry';
import { FormDescriptor } from '../../form/model/form';
import { ApiProfileDescriptor } from '../../profile/model/api.profile';
import { OrganizationModel } from '../../organization/model/organization.model';

export enum ClarificationRequestState {
  Created,
  Sent,
  Approved,
  Disputed,
  Closed,
  Forced
}

export class ClarificationRequestStateDetail implements ModuleModel {
  public discriminator = 'ClarificationRequestStateDetail';
  public id: string;
  public name: string;

  constructor(options?: {
    id: string,
    name: string,
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
    }
  }
}

export const ClarificationRequestStateMap = {
  Created: new ClarificationRequestStateDetail({ id: 'Created', name: 'Létrehozva' }),
  Sent: new ClarificationRequestStateDetail({ id: 'Sent', name: 'Elküldve' }),
  Approved: new ClarificationRequestStateDetail({ id: 'Approved', name: 'Elfogadva' }),
  Disputed: new ClarificationRequestStateDetail({ id: 'Disputed', name: 'Vitatva' }),
  Closed: new ClarificationRequestStateDetail({ id: 'Closed', name: 'Lezárva' }),
  Forced: new ClarificationRequestStateDetail({ id: 'Forced', name: 'Kötelezve' })
};

export const ClarificationRequestStateList: ClarificationRequestStateDetail[] = [
  ClarificationRequestStateMap.Created,
  ClarificationRequestStateMap.Sent,
  ClarificationRequestStateMap.Approved,
  ClarificationRequestStateMap.Disputed,
  ClarificationRequestStateMap.Closed,
  ClarificationRequestStateMap.Forced
];

export class ClarificationRequestDescriptor implements ModuleModel {
  public discriminator = 'ClarificationRequestDescriptor';

  public id: string;
  public dataEntryId: string;
  public organizationId: string;
  public formId: string;
  public submittedBy: string;
  public submittedOn?: Date;
  public clarificationRequestState: ClarificationRequestState;
  public isArguable: boolean;

  public href: string;
  public modified: Date;
  public deleted: Date;

  public dataEntryDetail: DataEntryDescriptor;
  public dataEntryReference: string;
  public dataEntryVersion?: number;
  public dataEntryPeriodStart?: Date;

  public organizationDetail: OrganizationModel;
  public organizationMekhCode?: string;
  public organizationName?: string;
  public organizationTitleToDisplay?: string;

  public formDetail: FormDescriptor;
  public formIdentifier?: string;
  public formVersion?: number;
  public formTitle?: string;
  public formTitleToDisplay?: string;

  public submittedByDetail: ApiProfileDescriptor;
  public submittedByFullName?: string;

  constructor(options?: {
    id: string;
    dataEntryId: string;
    organizationId: string;
    formId: string;
    submittedBy: string;
    submittedOn?: Date;
    clarificationRequestState: ClarificationRequestState;
    isArguable: boolean;

    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;
      this.dataEntryId = options.dataEntryId;
      this.organizationId = options.organizationId;
      this.formId = options.formId;
      this.submittedBy = options.submittedBy;
      this.submittedOn = options.submittedOn;
      this.clarificationRequestState = options.clarificationRequestState;
      this.isArguable = options.isArguable;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }
  }
}

export enum ClarificationRequestMachineAttributeName {
  Request,
  Response
}

export class ClarificationRequestMachineAttribute {
  public name: ClarificationRequestMachineAttributeName;
  public value: string;

  constructor(options?: {
    name: ClarificationRequestMachineAttributeName;
    value: string;
  }) {

    if (options) {
      this.name = options.name;
      this.value = options.value;
    }
  }
}

export enum ClarificationRequestMachineCommand {
  Send,
  Approve,
  Reject,
  Close
}

export const ClarificationRequestMachineCommandMessage = {
  Send: { done: 'A adategyeztetés elküldése sikeresen megtörtént.', fail: 'A adategyeztetés elküldése nem sikerült.' },
  Approve: { done: 'A adategyeztetés jóváhagyása sikeresen megtörtént.', fail: 'A adategyeztetés jóváhagyása nem sikerült.' },
  Reject: { done: 'A adategyeztetés vitatása sikeresen megtörtént.', fail: 'A adategyeztetés vitatása nem sikerült.' },
  Close: { done: 'A adategyeztetés lezárása sikeresen megtörtént.', fail: 'A adategyeztetés lezárása nem sikerült.' },
  Force: { done: 'A adategyeztetés kötelezése sikeresen megtörtént.', fail: 'A adategyeztetés kötelezése nem sikerült.' }
};

export class ClarificationRequestMachineStateDescriptor implements ModuleModel {
  public discriminator = 'ClarificationRequestMachineStateDescriptor';

  public command?: ClarificationRequestMachineCommand;
  public attributes?: ClarificationRequestMachineAttribute[];

  constructor(options?: {
    command?: ClarificationRequestMachineCommand;
    attributes?: ClarificationRequestMachineAttribute[];
  }) {

    if (options) {
      this.command = options.command;
      this.attributes = options.attributes;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/clarification.request/model/clarification.request.ts